import React from 'react';
// Modules
import Table from 'react-bootstrap/Table';
// Components
import { NoData } from './components/NoData';
import { Loading } from './components/Loading';
import { getColumns } from './components/Column';
import Row from './components/Row';
// Icons
import { FaSort, FaSortDown, FaSortUp } from 'react-icons/fa6';

const TableHeader = ({ columns, headers }) => {
  const renderSortTypeIcon = (column) => {
    if (column.sorting.sort.accessor === column.accessor) {
      switch (column.sorting.sort.type) {
        case 'asc':
          return <FaSortUp />;
        case 'desc':
          return <FaSortDown />;
        default:
          return <FaSort />;
      }
    } else {
      return <FaSort />;
    }
  };

  return (
    <thead>
      {headers && (
        <tr className="table--sub-header">
          {headers.map((header, index) => (
            <th key={index} colSpan={header.colSpan} className={header.headerClass}>
              {header.text}
            </th>
          ))}
        </tr>
      )}
      <tr className="table--main-header">
        {columns.map((column, index) => (
          <th key={index} colSpan={column.colSpan} className={column.headerClass}>
            {column.sorting ? (
              <span className="cursor-pointer" onClick={() => column.sorting.apply(column.accessor)}>
                {column.header} {renderSortTypeIcon(column)}
              </span>
            ) : (
              column.header
            )}
          </th>
        ))}
      </tr>
    </thead>
  );
};

const TableBody = ({ data, columns }) => {
  return (
    <tbody>
      {data.map((item, rowIndex) => (
        <tr key={rowIndex}>
          <Row item={item} columns={columns} />
        </tr>
      ))}
    </tbody>
  );
};

const DataTable = ({ data, headers, columns }) => {
  return (
    <Table borderless className="borderless table-striped table-borderless table">
      <TableHeader columns={columns} headers={headers} />
      <TableBody data={data} columns={columns} />
    </Table>
  );
};

const DefaultTable = ({ data, headers = null, isLoading, children }) => {
  if (isLoading) {
    return <Loading />;
  }

  if (data) {
    if (data.length === 0) {
      return <NoData />;
    } else {
      const columns = getColumns(children);
      return <DataTable data={data} headers={headers} columns={columns} />;
    }
  }
};

export default DefaultTable;
